import { render, staticRenderFns } from "./barColumnRotateLabelChart.vue?vue&type=template&id=24b2b868"
import script from "./barColumnRotateLabelChart.vue?vue&type=script&lang=js"
export * from "./barColumnRotateLabelChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports